/* @flow */
import Dispatcher, { dispatcher } from 'lib/Dispatcher';
import EventEmitter from 'events';
import { EventEmitter as FbEmitter } from 'fbemitter';

// $FlowIssue
EventEmitter.defaultMaxListeners = Number.MAX_VALUE;

class Store extends EventEmitter {
  constructor() {
    super();

    this.__changeEvent = 'change';
    this.__fbemitter = new FbEmitter();
    this.__dispatcher = dispatcher;

    this._dispatchToken = dispatcher.register(this.getDispatchHandler());
    this.state = this.getInitialState();

    if (__DEV__ && typeof window !== 'undefined') {
      window.stores = window.stores || {};
      window.stores[this.constructor.name] = this;
    }
  }

  state: Object;
  __dispatcher: Dispatcher;
  _dispatchToken: *;
  __changeEvent: string;
  __fbemitter: FbEmitter;

  setState(state: Object) {
    this.state = state;
    this.emitChange();
  }

  resetState(): void {
    this.setState(this.getInitialState());
  }

  getDispatchHandler(): Function {
    return this.handleDispatch.bind(this);
  }

  /* This should be overridden in subclasses */
  handleDispatch(_action: Object): void {
    return undefined;
  }

  /* This should be overridden in subclasses */
  getInitialState(): * {
    return {};
  }

  emitChange() {
    this.emit(this.__changeEvent);
    this.__fbemitter.emit(this.__changeEvent);
  }

  /**
   * @deprecated older Node-style event emitter
   * @param {Function} callback [description]
   */
  addChangeListener(callback: Function) {
    this.on(this.__changeEvent, callback);
  }

  waitFor(stores: Store[]) {
    return this.__dispatcher.waitFor(stores.map(store => store._dispatchToken));
  }

  //
  // interfaces for FluxUtils
  //

  /**
   * @public
   * @param {function} callback
   * @return {object} EmitterSubscription that can be used with
   *   SubscriptionsHandler or directly used to release the subscription.
   */
  // XXX this signature doesn't match EventEmitter parent
  // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
  addListener(callback: Function) {
    return this.__fbemitter.addListener(this.__changeEvent, callback);
  }

  /**
   * @public
   * @return {Dispatcher} The dispatcher that this store is registered with.
   */
  getDispatcher(): Dispatcher {
    return this.__dispatcher;
  }

  /**
   * @public
   * @return {string} A string the dispatcher uses to identify each store's
   *   registered callback. This is used with the dispatcher's waitFor method
   *   to declaratively depend on other stores updating themselves first.
   */
  getDispatchToken(): * {
    return this._dispatchToken;
  }
}

export default Store;



// WEBPACK FOOTER //
// ./src/lib/Store.js